export enum ToastIcon {
  Success,
  Warning,
}